module.exports = __webpack_public_path__ + "static/media/defaultEmail.042890cd.svg";